import script from "./SideNav.vue?vue&type=script&setup=true&lang=js"
export * from "./SideNav.vue?vue&type=script&setup=true&lang=js"

import "./SideNav.vue?vue&type=style&index=0&id=5b023ad2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b023ad2"]])

export default __exports__